import type { ICompetencyItem } from './competency';
import type { IAccreditationBody } from './accreditation-body';

export enum AuthorizationLevel {
  LEAD = 'LEAD',
  COMPETENT = 'COMPETENT',
  EXPERT = 'EXPERT',
}

export interface IAuthorizationItem {
  id: number;
  validFrom: Date;
  validTo: Date;
  level: AuthorizationLevel;
  competency: ICompetencyItem;
  accreditationBody?: IAccreditationBody;
  name?: string;
}
